export default "__VITE_ASSET__kVDOI7wC__"